import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 10",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.70711 0.292893C6.09763 0.683417 6.09763 1.31658 5.70711 1.70711L3.41421 4H11C11.5523 4 12 4.44771 12 5C12 5.55228 11.5523 6 11 6H3.41421L5.70711 8.29289C6.09763 8.68342 6.09763 9.31658 5.70711 9.7071C5.31658 10.0976 4.68342 10.0976 4.29289 9.7071L0.292893 5.70711C-0.0976311 5.31658 -0.0976311 4.68342 0.292893 4.29289L4.29289 0.292893C4.68342 -0.0976311 5.31658 -0.0976311 5.70711 0.292893Z",
		fill: "var(--color, #123C70)"
	})
});
export default SvgArrowLeft;
